module.exports = __webpack_public_path__ + "mg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mg.svg
// module id = 941
// module chunks = 0